var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-container"},[_c('PageHeader'),_vm._v(" "),_c('nuxt',{staticClass:"pc-content"}),_vm._v(" "),_c('PageFooter',{staticClass:"pc-footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }